import { render, staticRenderFns } from "./CreateCustomerPopUp.vue?vue&type=template&id=4bbb0392&scoped=true&"
import script from "./CreateCustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerPopUp.vue?vue&type=style&index=0&id=4bbb0392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb0392",
  null
  
)

export default component.exports